import { ProtectedServerPlaceEvent, SubscriptionDto } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { Action } from 'redux-act';
import { delay, put, takeEvery } from 'redux-saga/effects';

import { fromDto } from '../../../models/adapters/SubscriptionAdapter';
import { waitBeforeFetch } from '../../../utils/FetchState';
import { fetchSubscriptions, FetchSubscriptionsPayload, subscriptionsFetched, subscriptionsFetchFailed } from '../../actions/subscription/fetchSubscriptions';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* fetchSubscriptionsSaga({ payload }: Action<FetchSubscriptionsPayload>) {
  const timestamp = moment();
  const token = yield getAuthenticationToken();
  const { fetchState, feature, placeUuid } = payload;
  const milliseconds = waitBeforeFetch(fetchState);
  yield delay(milliseconds);
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.getSubscriptions, token, { feature, placeUuid });
  const { subscriptions, error } = response;
  if (!error) {
    const responsePayload = {
      subscriptions: subscriptions.map((subscription: SubscriptionDto) => fromDto(subscription)),
      feature,
      placeUuid,
      timestamp,
    };
    const responseAction = subscriptionsFetched(responsePayload);
    yield put(responseAction);
  } else {
    const responseAction = subscriptionsFetchFailed({ timestamp, feature, placeUuid });
    yield put(responseAction);
  }
}

export default function* watchFetchSubscriptionsSaga() {
  yield takeEvery(fetchSubscriptions, fetchSubscriptionsSaga);
}
